// Module H2 messagerie (interface) : points d'intégration dans le routeur, la coquille, la navigation et l'aide.

import { createElement } from 'react';
import { PageMessagerie } from './Messagerie';

export { PageMessagerie, AccesMessagerie } from './Messagerie';
export { FilConversation } from './Fil';
export { MessageItem } from './MessageItem';
export { NouvelleConversation } from './NouvelleConversation';

export const inscription = {
  nom: 'messagerie',
  routes: [
    { chemin: '/messages', element: createElement(PageMessagerie) },
    { chemin: '/messages/nouvelle', element: createElement(PageMessagerie, { nouvelle: true }) },
    { chemin: '/messages/:id', element: createElement(PageMessagerie) },
  ],
  /** Élément de la barre supérieure (coquille) : accès aux messages avec le nombre de conversations non lues. */
  barre: ['AccesMessagerie'],
  pages: [
    {
      motif: /^\/messages$/,
      libelle: 'Messages',
      parent: '/',
      aide: 'Conversations individuelles, groupes internes, canaux de service rattachés aux livraisons, alertes, inspections, incidents, rapprochements et cargaisons, canal de crise et annonces. Deux distributeurs ne peuvent échanger que dans un canal de crise. La recherche porte sur vos propres conversations.',
    },
    {
      motif: /^\/messages\/nouvelle$/,
      libelle: 'Nouvelle conversation',
      parent: '/messages',
      aide: 'Une conversation individuelle réunit deux personnes de la même organisation ou d’organisations en relation déclarée ou partageant un objet commun. Un groupe est interne à votre organisation. Les annonces sont émises par le ministère et la DGH.',
    },
    {
      motif: /^\/messages\/[^/]+$/,
      libelle: 'Conversation',
      parent: '/messages',
      aide: 'Un message se modifie pendant 15 minutes, avec mention et historique ; un masquage garde une trace. Les décisions officielles consignées dans un canal de crise ne sont jamais modifiables. Les pièces jointes héritent des droits de la conversation et se téléchargent par un lien signé de 5 minutes.',
    },
  ],
} as const;
